<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" @input="getCourse"/>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="courseItems"
            type="search"
            itemText="educationCourseName"
            itemValue="eduCourseId"
            name="eduCourseId"
            label="교육과정"
            v-model="searchParam.eduCourseId"
          >
          </c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 진행상태 -->
          <c-select
            type="search"
            codeGroupCd="EDU_STATUS_CD"
            itemText="codeName"
            itemValue="code"
            name="documentStatusCd"
            label="진행상태"
            v-model="searchParam.documentStatusCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="none"
            :comboItems="kindItems"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdLarge"
            label="교육종류1"
            v-model="searchParam.educationKindCdLarge"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            codeGroupCd="EDU_KIND_SEC_CD"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdSmall"
            label="교육종류2"
            v-model="searchParam.educationKindCdSmall"
          ></c-select>
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-select
            type="search"
            codeGroupCd="EDU_CLASS_CD"
            itemText="codeName"
            itemValue="code"
            name="educationTypeCd"
            label="교육구분"
            v-model="searchParam.educationTypeCd"
          ></c-select>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 점검일 -->
          <c-datepicker
            :range="true"
            :isToyear="true"
            name="period"
            label="교육기간"
            v-model="period"
          ></c-datepicker>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-checkbox
            :isFlag="true"
            falseLabel="All"
            label="미완료된 교육"
            name="delayFlag"
            v-model="searchParam.delayFlag"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="교육계획및결과 목록"
      tableId="table"
      :columns="grid.columns"
      :data="grid.data"
      :merge="grid.merge"
      :checkClickFlag="false"
      rowKey="eduEducationId"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group outline>
            <c-btn v-show="isCourse && editable" label="교육과정별 대상자" icon="check" @btnClicked="select" />
            <c-btn v-if="editable" label="등록" icon="add" @btnClicked="onItemClick('A')" />
            <!-- <c-btn label="삭제" :editable="editable" icon="delete_forever" @btnClicked="onItemClick('D')" /> -->
            <c-btn label="검색"  icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
      
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name==='documentStatusName'">
          <span>
            {{props.row.documentStatusName}}
            <q-badge v-if="props.row.delayFlag === 'Y'" color="negative" label="미완료" class="blinking" />
            <q-badge v-if="props.row.tempFlag === 'Y'" color="orange" label="진행중"  />
          </span>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: "education-result",
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          mainPeriod: [],
          mainPlantCd: null,
          plantCd: null,
          period: [],
        }
      },
    },
    eduInfo: {
      type: Object,
      default(){
        return {
          educationKindCdLarge: '',
          delAuth: '', // process menaul
        }
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            style: 'width:80px',
            align: "center",
            sortable: true,
          },
          // {
          //   name: "deptNm",
          //   field: "deptNm",
          //   label: "부서",
          //   align: "center",
          //   sortable: true,
          // },
          {
            name: "educationName",
            field: "educationName",
            label: "교육명",
            style: 'width:250px',
            align: "left",
            sortable: true,
            type: "link",
          },
          {
            name: "educationCourseName",
            field: "educationCourseName",
            label: "교육과정",
            style: 'width:300px',
            align: "left",
            sortable: true,
          },
          {
            name: "educationDate",
            field: "educationDate",
            label: "교육일",
            style: 'width:200px',
            align: "center",
            sortable: true,
          },
          {
            name: "educationTime",
            field: "educationTime",
            label: "교육시간",
            style: 'width:100px',
            align: "center",
            sortable: true,
          },
          {
            name: "educationKindCdLargeName",
            field: "educationKindCdLargeName",
            label: "교육종류1",
            style: 'width:150px',
            align: "center",
            sortable: true,
          },
          {
            name: "educationKindCdSmallName",
            field: "educationKindCdSmallName",
            label: "교육종류2",
            style: 'width:150px',
            align: "center",
            sortable: true,
          },
          {
            name: "documentStatusName",
            field: "documentStatusName",
            label: "진행상태",
            style: 'width:90px',
            align: "center",
            type: 'custom',
            sortable: true,
          },
          {
            name: "educationMethodName",
            field: "educationMethodName",
            style: 'width:90px',
            label: "교육방법",
            align: "center",
            sortable: true,
          },
          // {
          //   name: "evaluationEvalName",
          //   field: "evaluationEvalName",
          //   style: 'width:90px',
          //   label: "교육평가",
          //   align: "center",
          //   sortable: true,
          // },
          // {
          //   name: "educationOverview",
          //   field: "educationOverview",
          //   style: 'width:200px',
          //   label: "교육총평",
          //   align: "left",
          //   sortable: true,
          // },
          {
            name: "educationPurpose",
            field: "educationPurpose",
            style: 'width:200px',
            label: "학습목적",
            align: "left",
            sortable: true,
          },
          {
            name: "relatedLawsName",
            field: "relatedLawsName",
            style: 'width:200px',
            label: "관련법규",
            align: "left",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        documentStatusCd: null,
        startYmd: '',
        endYmd: '',
        educationKindCdSmall: null,
        educationKindCdLarge: null,
        educationTypeCd: null,
        eduCourseId: null,
        delayFlag: 'N',
      },
      kindItems: [],
      period: [],
      editable: true,
      listUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      isResult: false,
      deleteUrl: '',
      courseUrl: '',
      courseItems: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    isCourse() {
      return Boolean(this.searchParam.eduCourseId)
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // 메인에서 호출한 팝업파라미터
      // if (this.popupParam.mainPeriod.length > 0  || this.popupParam.mainPlantCd) {
      //   this.searchParam.plantCd = (!this.popupParam.mainPlantCd || this.popupParam.mainPlantCd.length > 3 ? null : this.popupParam.mainPlantCd);
      //   this.period = this.popupParam.mainPeriod;
      // } else {
      //   this.period = [this.$comm.getFirstDayThisYear(), this.$comm.getLastDayThisYear()];
      // }
      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd
      }
      if (this.popupParam.period ) {
        this.searchParam.plantCd = (!this.popupParam.plantCd || this.popupParam.plantCd.length > 3 ? null : this.popupParam.plantCd);
        this.period = this.popupParam.period;
      } else {
        this.period = [this.$comm.getThisYear() + '-01-01', this.$comm.getToday()]
      }
      // url setting
      this.courseUrl = selectConfig.sop.edu.course.list.url;
      this.listUrl = selectConfig.sop.edu.result.list.url;
      this.deleteUrl = transactionConfig.sop.edu.annual.delete.url;
      // code setting
      if (this.eduInfo.educationKindCdLarge) {
        this.searchParam.educationKindCdLarge = this.eduInfo.educationKindCdLarge;
      }
      this.$comm.getComboItems('EDU_KIND_FST_CD').then(_result => {
        let attrVal1 = null;
        if (this.eduInfo.educationKindCdLarge) {
          attrVal1 = this.eduInfo.educationKindCdLarge == 'EKFC000001' ? 'SAF' : 'ENV'
          _result = this.$_.filter(_result, { attrVal1 : attrVal1 });
        }
        _result.splice(0, 0, {
          codeName: '전체',
          code: attrVal1,
        })
        this.$set(this.$data, 'kindItems', _result)
      });
      // list setting
      this.getCourse();
      this.getList();
    },
    getCourse() {
      if (this.searchParam.plantCd) {
        this.$http.url = this.courseUrl;
        this.$http.type = 'GET';
        this.$http.param = {plantCd: this.searchParam.plantCd, useFlag: 'Y'};
        this.$http.request((_result) => {
          this.courseItems = _result.data;
          this.searchParam.eduCourseId = null;
        },);
      } else {
        this.courseItems = [];
      }
    },
    getList() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }

      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(row, col, index) {
      this.popupOptions.title = "교육계획 및 결과 상세"; // 교육계획 상세
      this.popupOptions.param = {
        plantCd: row.plantCd ? row.plantCd : this.searchParam.plantCd,
        eduEducationId: row.eduEducationId ? row.eduEducationId : '',
        stepCd: row.documentStatusCd === 'ESC000001' ?  'ESC0000005' : 'ESC0000010',
        educationKindCdLarge: this.eduInfo.educationKindCdLarge ? this.eduInfo.educationKindCdLarge: null,
        delAuth: this.eduInfo.delAuth
      };
      this.popupOptions.target = () =>
        import(`${"./educationResultDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    onItemClick(data) {
      if (data === 'A') { // 상세
        this.popupOptions.target = () =>
        import(`${"./educationResultDetail.vue"}`);
        this.popupOptions.visible = true;
        this.popupOptions.isFull = true;
        this.popupOptions.title = '교육계획 및 결과 상세'; // 교육계획 상세
        this.popupOptions.param = {
          eduEducationId: '',
          stepCd: 'ESC0000005',
          educationKindCdLarge: this.eduInfo.educationKindCdLarge ? this.eduInfo.educationKindCdLarge: null,
        };
      }
      this.popupOptions.closeCallback = this.closePopup;
    },
    select() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.popupOptions.title = "교육과정별 대상자 연명부"; // 교육계획 상세
      this.popupOptions.param = {
        plantCd: this.searchParam.plantCd,
        eduCourseId: this.searchParam.eduCourseId,
        startYmd: this.searchParam.startYmd,
        endYmd: this.searchParam.endYmd,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/edu/educationTargetUsersPop.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = '95%';
      this.popupOptions.closeCallback = this.closePopup;
    },
  },
};
</script>
